"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutCurrency = exports.TournamentStatus = exports.TournamentConfigTypes = void 0;
var TournamentConfigTypes;
(function (TournamentConfigTypes) {
    TournamentConfigTypes["LONGEST_DRIVE"] = "LONGEST_DRIVE";
    TournamentConfigTypes["COURSE_TOURNAMENT"] = "COURSE_TOURNAMENT";
    TournamentConfigTypes["CLOSEST_TO_PIN"] = "CLOSEST_TO_PIN";
    TournamentConfigTypes["ORDER_OF_MERIT"] = "ORDER_OF_MERIT";
})(TournamentConfigTypes = exports.TournamentConfigTypes || (exports.TournamentConfigTypes = {}));
var TournamentStatus;
(function (TournamentStatus) {
    TournamentStatus["LIVE"] = "LIVE";
    TournamentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TournamentStatus["WAITING"] = "WAITING";
    TournamentStatus["ENDED"] = "ENDED";
    TournamentStatus["UNKNOWN"] = "UNKNOWN";
})(TournamentStatus = exports.TournamentStatus || (exports.TournamentStatus = {}));
var PayoutCurrency;
(function (PayoutCurrency) {
    PayoutCurrency["POINTS"] = "POINTS";
    PayoutCurrency["TICKETS"] = "TICKETS";
    PayoutCurrency["CASH"] = "CASH";
})(PayoutCurrency = exports.PayoutCurrency || (exports.PayoutCurrency = {}));
//# sourceMappingURL=TournamentTypes.js.map